export default "__VITE_ASSET__DjjrGJxn__"